// Packages
import { createAsyncThunk } from '@reduxjs/toolkit';
// API
import { ScansAPI } from 'api/endpoints';
// Interfaces and types
import {
  IGetScansRes,
  IGetScanDetails,
  IUpdateScanBodyWithParams,
  IUpdateScanRes,
  IDeleteScanParams,
  IDeleteScanRes,
} from 'types/scans';
import { TQueryParams, IErrorRes } from 'types/appTypes';

const getScansAsync = createAsyncThunk<IGetScansRes, TQueryParams, { rejectValue: IErrorRes }>(
  'scans/getScans',
  async (params: TQueryParams, { rejectWithValue }) => {
    try {
      return await ScansAPI.getScans(params);
    } catch (error) {
      return rejectWithValue(error as IErrorRes);
    }
  },
);

const getScanDetailsAsync = createAsyncThunk<
  IGetScanDetails,
  number,
  { rejectValue: IErrorRes }
>('scans/getScanDetails', async (params: number, { rejectWithValue }) => {
  try {
    return await ScansAPI.getScanDetails(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const updateScanAsync = createAsyncThunk<
  IUpdateScanRes,
  IUpdateScanBodyWithParams,
  { rejectValue: IErrorRes }
>('scans/updateScan', async (cred: IUpdateScanBodyWithParams, { rejectWithValue }) => {
  try {
    return await ScansAPI.updateScanDetails(cred);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const deleteScanAsync = createAsyncThunk<
  IDeleteScanRes,
  IDeleteScanParams,
  { rejectValue: IErrorRes }
>('scans/deleteScan', async (params: IDeleteScanParams, { rejectWithValue }) => {
  try {
    return await ScansAPI.deleteScanDetails(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

export { getScansAsync, getScanDetailsAsync, updateScanAsync, deleteScanAsync };
